import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderPublicComponent } from './header-public/header-public.component';
import { FooterPublicComponent } from './footer-public/footer-public.component';

import { InicioRegistroComponent } from './inicio-registro/inicio-registro.component';
import { InicioSesionComponentCore } from './inicio-sesion/inicio-sesion.component';
import { VerificacionCorreoComponent } from './verificacion-correo/verificacion-correo.component';
import { LandingAceptacionUsuarioComponent } from './landing-aceptacion-usuario/landing-aceptacion-usuario.component';
import { LandingAceptacionCreacionCreditoComponent } from './landing-aceptacion-creacion-credito/landing-aceptacion-creacion-credito.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { LandingAceptacionAliadoComponent } from './landing-aceptacion-aliado/landing-aceptacion-aliado.component';
import { HeaderHomeComponent } from './header-home/header-home.component';
import { HomeSiteFooterComponent } from '../page/home/components/home-site-footer/home-site-footer.component';
import { ContactoAtencionInfoComponent } from '../shared/components/contacto-atencion-info/contacto-atencion-info.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    HeaderPublicComponent,
    FooterPublicComponent,
    InicioRegistroComponent,
    InicioSesionComponentCore,
    VerificacionCorreoComponent,
    LandingAceptacionUsuarioComponent,
    LandingAceptacionCreacionCreditoComponent,
    LandingAceptacionAliadoComponent,
    HeaderHomeComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    HomeSiteFooterComponent,
    ContactoAtencionInfoComponent,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    HeaderPublicComponent,
    FooterPublicComponent,
    InicioRegistroComponent,
    InicioSesionComponentCore,
    VerificacionCorreoComponent,
    LandingAceptacionUsuarioComponent,
    LandingAceptacionCreacionCreditoComponent,
    LandingAceptacionAliadoComponent,
    HeaderHomeComponent,
    HomeSiteFooterComponent,
  ]
})
export class CoreModule { }
